import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

// Components

import UniversalInput from '../../../../../lib/wrappers/UniversalInput';
import ValidationErrorMessage from '../../../notifications/ValidationErrorMessage';

// Utils

import { normalizeNameOfPerson } from '../../../../../utils/normalize/normalizeNameOfPerson';
import { getHhmByPersonId } from '../../../../../utils/normalize/getHhmByPersonId';

// Constants

import { INPUT_TYPES } from '../../../../../constants/inputs/inputTypes';
import { VALIDATION_ERROR_MESSAGES } from '../../../../../constants/inputs/validationErrorMessages';




const PrimaryFilerBlock = props => {
    const {
        family,
        householdMembers,
        onFieldChange,
        primaryTaxFilerPersonId,
        isFormSubmitted,
        isFormOnTopLevelValid,
        ...restProps
    } = props;

    const getPrimaryTaxFilerMessage = () => {

        const getPrimaryTaxFilerName = () => primaryTaxFilerPersonId ?
            normalizeNameOfPerson(getHhmByPersonId(primaryTaxFilerPersonId, householdMembers).name) :
            <FormattedMessage id='ssap.family_household.tax_composition.no_primary_tax_filer'/>;

        return (
            <FormattedMessage 
                id='ssap.family_household.tax_composition.primary_tax_filer_is'
                values={{
                    primaryTaxFilerName: <strong>{ getPrimaryTaxFilerName() }</strong>
                }}
            />
        );
    };

    const getChosenFilersList = () => {

        return family.filers.filter(filer => filer.isFilingTaxes).map(filer => {

            const {
                filerPersonId,
                filerFullName,
                filerIndex
            } = filer;

            const isPrimaryTaxFiler = primaryTaxFilerPersonId === filerPersonId;

            return (
                <UniversalInput
                    key={filerPersonId}
                    label={{
                        text: 'common.input.label.non_internationalized_text',
                        labelTextReplacements: {
                            text: filerFullName
                        }
                    }}
                    inputData={{
                        isInputRequired: false,
                        type: INPUT_TYPES.CHECKBOX,
                        name: 'isPrimaryTaxFiler',
                        classes: [''],
                        checked: isPrimaryTaxFiler,
                        value: isPrimaryTaxFiler,
                        currentData: { },
                        fields: [],
                    }}
                    inputActions={{
                        onFieldChange
                    }}
                    indexInArray={filerIndex}
                    {...restProps}
                />
            );
        });
    };

    return family.filersQty < 2 ?

        (primaryTaxFilerPersonId === 0 ?
            null :
            <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
                <div className="usa-alert__body gi-alert__info__body">
                    <p className="usa-alert__text gi-alert__info__text">
                        { getPrimaryTaxFilerMessage() }
                    </p>
                </div>
            </div>
        ) :
        <div className="subsection">
            <ValidationErrorMessage
                isVisible={isFormSubmitted && !isFormOnTopLevelValid && !(family.filersQty > 1 ? primaryTaxFilerPersonId !== 0 : true)}
                messageText={VALIDATION_ERROR_MESSAGES.PRIMARY_TAX_FILER}
                errorClasses={['margin-l-0', 'margin-b-10']}
            />
            <p className="required-true">
                <FormattedMessage id='ssap.family_household.tax_composition.select_primary_tax_filer'/>
            </p>
            {
                getChosenFilersList()
            }
        </div>;
};

export default PrimaryFilerBlock;